<template>
  <span :class="`label label--${identifier}`">
    {{ text }}
  </span>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
    },

    identifier: {
      type: String,
    },
  },
};
</script>

<style scoped>
.label {
  border-radius: 2rem;
  padding: .375rem .75rem .5rem;
  display: inline-block;
  font-weight: 700;
  font-size: .9375rem;
  color: #fff;
  background-color: rgba(42, 21, 88, 1);
}

.label--pending { color: #fff; background-color: rgba(188, 85, 23, 1); }
.label--resolved { color: #0d3114; background-color: rgba(72, 240, 107, 1); }
.label--closed { color: #eb6619; background-color: rgba(235, 102, 25, .15); }
/* .label--open { background-color: rgba(); } */
/* .label--waiting_on_customer { background-color: rgba(); } */
/* .label--waiting_on_third_parties { background-color: rgba(); } */
/* .label--unknown { background-color: rgba(); } */
/* .label--internally_pending { background-color: rgba(); } */
/* .label--scheduled { background-color: rgba(); } */
</style>
